module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/reward_badge_silver_ghost-efef99d8cae0fce0132916145d743363.svg";